// Copyright (c) 2017 Deere & Company

import AuditClaimsFacets from './audit-claims-facets';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facets: state.tcsm.addClaimsToAudit.facets
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...parentProps,
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AuditClaimsFacets);




// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/facets/index.js